import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const NotFound = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-slate-900 via-black  to-teal-700 text-white p-5">
      <div className="text-center">
        <h1 className="text-9xl font-extrabold">404</h1>
        <p className="text-3xl mt-4">Oops! Page not found.</p>
        <p className="mt-2 text-lg">The page you are looking for does not exist. It might have been moved or deleted.</p>
        <Link to="/" className="mt-8 inline-flex items-center px-6 py-3 bg-white text-teal-600 font-semibold rounded-full shadow-lg hover:bg-gray-200 transition duration-300">
          <FaArrowLeft className="mr-2" /> Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
